import { ChangeEvent } from "react";

import { useTranslation } from "react-i18next";

import InputField from "../../components/InputField/InputField";
import useLogin from "../../Pages/Auth/hooks/useLogin";

interface OtpInputFieldProps {
  isLoading: boolean;
  error: string | null;
  value: string;
  onChange: (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  onBlur: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  isRequired?: boolean;
  label?: string;
}

export const OtpInputField = ({
  isLoading,
  error,
  value,
  onChange,
  onBlur,
  isRequired,
  label
}: OtpInputFieldProps) => {
  const { generateCodeinputLabel } = useLogin();
  const { t } = useTranslation();

  return (
    <InputField
      data-testid="otp-input-field"
      autoFocus
      autoComplete="one-time-code"
      fullWidth
      value={value}
      required={isRequired}
      disabled={isLoading}
      errorText={error}
      labelLeft={label || generateCodeinputLabel(t)}
      placeholder={t("Dialog##enter")}
      size="medium"
      onChange={onChange}
      onBlur={onBlur}
    />
  );
};
